import React, { useEffect, useMemo, useState } from 'react'
import styles from './DetailSaleModal.module.css'
import ModalComponent from './ModalComponent'
import Text from '../text/Text'
import { format, parseISO } from 'date-fns'
import { TransactionResponse } from '../../services/commerce'
import { formatCurrency } from '../../utils'
import { getLocalAddress, getLocalName } from '../../Utils/Profile'
import check from '../../assets/icons/comprobante-check.png'
import alert from '../../assets/images/warning.png'
import SvgIcon from '../svgIcon/SvgIcon'
import { getTransactionBackoffice } from '../../services/orders'
import { getTokenName } from '../saleComponent/SaleComponent'
import { useTokensContext } from '../../context/tokensContext'
import { labels } from '../../labels'

interface IReceiptDetail {
    onClose?: () => void
    sale: TransactionResponse
    onGoHome?: () => void
    customBtnText?: string
    onCustomBtn?: () => void
}

interface IReceiptModalDetail extends IReceiptDetail {
    isOpen: boolean
}

interface IItemCollapse {
    title: string
    subtitle: string
    value: string
}

interface IFooterItemCollapse {
    title: string
    value: string
}

const ItemCollapse = ({ title, subtitle, value }: IItemCollapse) => {
    return (
        <div className={styles.collapseBodyItem}>
            <div className={styles.collapseBodyItemDetail}>
                <Text
                    label={title}
                    fontFamily="Montserrat"
                    fontSize={14}
                    fontWeight={600}
                    color="#565656"
                />
                <Text
                    label={subtitle}
                    fontFamily="Montserrat"
                    fontSize={12}
                    fontWeight={400}
                    color="#565656"
                />
            </div>
            <div className={styles.collapseBodyItemValue}>
                <Text
                    label={value}
                    fontFamily="Montserrat"
                    fontSize={14}
                    fontWeight={600}
                    color="#565656"
                />
            </div>
        </div>
    )
}

const FooterItemCollapse = ({ title, value }: IFooterItemCollapse) => {
    return (
        <div className={styles.collapseFooterItem}>
            <Text
                label={title}
                fontFamily="Montserrat"
                fontSize={14}
                fontWeight={400}
                color="#787878"
            />
            <Text
                label={value}
                fontFamily="Montserrat"
                fontSize={14}
                fontWeight={600}
                color="#787878"
            />
        </div>
    )
}

export const DetailSale = ({
    sale,
    onClose,
    customBtnText,
    onGoHome,
    onCustomBtn,
}: IReceiptDetail) => {
    const tokens = useTokensContext()

    const tokenName = useMemo(
        () => getTokenName(sale.sToken, tokens),
        [sale.sToken, tokens]
    )

    const [openCollapse, setOpenCollapse] = useState(false)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [result, setResult] = useState<IOrderDetailsBackoffice>()

    console.log(sale)

    useEffect(() => {
        if (sale.idTransaccion) {
            getTransactionBackoffice(sale.idTransaccion, sale.sToken)
                .then((success) => {
                    setResult(success)
                    setShowAlert(
                        !!success.orderDetails.find((i) => i.active === true)
                    )
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }, [sale.idTransaccion])

    const totalDelivery = useMemo(() => {
        if (result) {
            return result.deliveryAmount || 0
        } else return 0
    }, [result])

    const totalAdditional = useMemo(() => {
        if (result) {
            return result.additionalAmount || 0
        } else return 0
    }, [result])

    return (
        <div className={styles.container}>
            <div className={styles.logo}>
                <img src={check} className="modal-img" />
            </div>

            <Text
                label="Comprobante de venta"
                fontSize={18}
                color="#000000"
                fontWeight={600}
                marginBottom={10}
                textAlign="center"
                fontFamily="Montserrat"
            />

            <Text
                label={`${getLocalName()}`}
                fontSize={24}
                color="#000000"
                fontWeight={600}
                marginBottom={10}
                textAlign="center"
                fontFamily="Montserrat"
            />

            <Text
                label={`${getLocalAddress()}`}
                fontSize={16}
                color="#464646"
                fontWeight={500}
                textAlign="center"
                fontFamily="Montserrat"
            />

            <Text
                label={formatCurrency(sale.nMonto)}
                fontSize={48}
                marginTop={16}
                color="#464646"
                fontWeight={600}
                marginBottom={16}
                textAlign="center"
                fontFamily="Montserrat"
            />

            <div className={styles.contentText}>
                <Text
                    label="Cod. Autorización:"
                    fontSize={14}
                    color="#565656"
                    fontWeight={700}
                    fontFamily="Montserrat"
                />

                <Text
                    label={` ${sale.idTransaccion || sale.authorizationCode}`}
                    fontSize={14}
                    color="#0086D6"
                    fontWeight={700}
                    fontFamily="Montserrat"
                />
            </div>

            <div className={styles.contentText}>
                <Text
                    label="Fecha: "
                    fontSize={14}
                    fontWeight={700}
                    color="#565656"
                    fontFamily="Montserrat"
                />
                <Text
                    label={`${format(
                        parseISO(sale.dTransaccion),
                        'dd/MM/yyyy - HH:mm'
                    )}`}
                    fontSize={14}
                    color="#0086D6"
                    fontWeight={700}
                    fontFamily="Montserrat"
                />
            </div>

            <div className={styles.contentText}>
                <Text
                    label="Medio de pago:"
                    fontSize={14}
                    fontWeight={700}
                    color={'#565656'}
                    fontFamily="Montserrat"
                />
                <Text
                    label={` ${
                        tokenName.includes(labels.bciPayment.bci)
                            ? 'POS BCI'
                            : tokenName.includes(labels.getnetPayment.getnet)
                            ? 'POS GETNET'
                            : tokenName
                    } `}
                    fontSize={14}
                    fontFamily="Montserrat"
                    fontWeight={700}
                    color={'#0086D6'}
                />
            </div>

            <Text
                label="amiPASS ®"
                fontSize={14}
                marginTop={20}
                fontWeight={400}
                color="#000000"
                marginBottom={20}
                textAlign="center"
                fontFamily="Montserrat"
            />

            {result &&
                Array.isArray(result.orderDetails) &&
                result.orderDetails.length > 0 && (
                    <>
                        {totalAdditional > 0 && (
                            <div className={styles.contentCollapseHeader}>
                                <div
                                    className={styles.collapseHeader}
                                    style={{ border: 0, marginBottom: 15 }}
                                >
                                    <Text
                                        label="Monto adicional"
                                        fontFamily="Montserrat"
                                        fontSize={14}
                                        fontWeight={400}
                                        color="#565656"
                                    />
                                    <Text
                                        label={formatCurrency(totalAdditional)}
                                        fontFamily="Montserrat"
                                        fontSize={14}
                                        fontWeight={600}
                                        color="#565656"
                                    />
                                </div>
                            </div>
                        )}

                        <div className={styles.collapse}>
                            <div
                                className={
                                    openCollapse
                                        ? styles.contentCollapseHeaderOpen
                                        : styles.contentCollapseHeader
                                }
                                onClick={() => setOpenCollapse(!openCollapse)}
                            >
                                <div className={styles.collapseHeader}>
                                    <Text
                                        label="Detalle producto"
                                        fontFamily="Montserrat"
                                        fontSize={14}
                                        fontWeight={400}
                                        color="#565656"
                                    />
                                    <div
                                        style={
                                            openCollapse
                                                ? {
                                                      transform:
                                                          'rotate(180deg)',
                                                  }
                                                : {}
                                        }
                                    >
                                        <SvgIcon iconName="IconDown" />
                                    </div>
                                </div>
                                <div className={styles.totalCollapseContainer}>
                                    {result &&
                                        Array.isArray(result.orderDetails) && (
                                            <div
                                                className={
                                                    styles.collapseHeaderTotal
                                                }
                                            >
                                                <SvgIcon iconName="IconCart" />
                                                <Text
                                                    label={`${result.orderDetails.reduce(
                                                        (
                                                            total: number,
                                                            curr: IOrderDetailsBackofficeItems
                                                        ) =>
                                                            total +
                                                            curr.totalItems,
                                                        0
                                                    )} Unidades`}
                                                    fontFamily="Montserrat"
                                                    fontSize={14}
                                                    fontWeight={600}
                                                    color="#565656"
                                                />
                                            </div>
                                        )}
                                    {!openCollapse && (
                                        <div className={styles.totalCollapse}>
                                            <Text
                                                label="Total: "
                                                fontFamily="Montserrat"
                                                fontSize={14}
                                                fontWeight={400}
                                                color="#565656"
                                            />
                                            <Text
                                                label={formatCurrency(
                                                    result.finalAmount || 0
                                                )}
                                                fontFamily="Montserrat"
                                                fontSize={14}
                                                fontWeight={600}
                                                color="#565656"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>

                            {openCollapse && (
                                <div className={styles.collapseBody}>
                                    {result.orderDetails.map(
                                        (
                                            item: IOrderDetailsBackofficeItems,
                                            key: number
                                        ) => (
                                            <ItemCollapse
                                                key={key}
                                                title={item.productName}
                                                subtitle={`Precio unidad: ${formatCurrency(
                                                    item.unitPrice
                                                )}`}
                                                value={`Cantidad: ${item.totalItems}`}
                                            />
                                        )
                                    )}
                                </div>
                            )}

                            {openCollapse && showAlert && (
                                <div className={styles.alertContent}>
                                    <div>
                                        <img src={alert} alt="warning" />
                                    </div>
                                    <Text
                                        fontSize={13}
                                        fontWeight={400}
                                        fontFamily="Montserrat"
                                        color="#000000"
                                        label="Este comprobante incluye todos los productos de la venta. Recuerda que si eliminas algún producto, estos desaparecerán de tu inventario, pero no de tus comprobantes de venta."
                                    />
                                </div>
                            )}

                            {openCollapse && (
                                <div className={styles.contentCollapseFooter}>
                                    <div className={styles.collapseFooter}>
                                        <FooterItemCollapse
                                            title="Monto inventario"
                                            value={formatCurrency(
                                                result.inventoryAmount || 0
                                            )}
                                        />
                                        {totalAdditional > 0 && (
                                            <FooterItemCollapse
                                                title="Monto adicional"
                                                value={formatCurrency(
                                                    totalAdditional
                                                )}
                                            />
                                        )}
                                        {totalDelivery > 0 && (
                                            <FooterItemCollapse
                                                title="Costo de envío"
                                                value={formatCurrency(
                                                    totalDelivery
                                                )}
                                            />
                                        )}
                                    </div>
                                    <div className={styles.collapseFooterTotal}>
                                        <Text
                                            label="Total de la venta:"
                                            fontFamily="Montserrat"
                                            fontSize={14}
                                            fontWeight={600}
                                            color="#565656"
                                        />
                                        <Text
                                            label={formatCurrency(
                                                result.finalAmount || 0
                                            )}
                                            fontFamily="Montserrat"
                                            fontSize={14}
                                            fontWeight={600}
                                            color="#565656"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}

            {onGoHome && (
                <div
                    className={styles.contentSecundaryBtn}
                    onClick={() => onGoHome()}
                >
                    <Text
                        label="IR A INICIO"
                        fontFamily="Montserrat"
                        textAlign="center"
                        fontWeight={600}
                        color="#0086d6"
                        fontSize={16}
                    />
                </div>
            )}

            {onClose && (
                <div className={styles.contentBtn} onClick={() => onClose()}>
                    <Text
                        label="Cerrar comprobante"
                        fontFamily="Montserrat"
                        textAlign="center"
                        fontWeight={600}
                        fontSize={16}
                        color="white"
                    />
                </div>
            )}

            {customBtnText && onCustomBtn && (
                <div
                    className={styles.contentBtn}
                    onClick={() => onCustomBtn()}
                >
                    <Text
                        label={customBtnText}
                        fontFamily="Montserrat"
                        textAlign="center"
                        fontWeight={600}
                        fontSize={16}
                        color="white"
                    />
                </div>
            )}
        </div>
    )
}

export const ReceiptModalDetail = ({
    sale,
    isOpen,
    onClose,
    customBtnText,
    onGoHome,
    onCustomBtn,
}: IReceiptModalDetail) => {
    return (
        <ModalComponent
            icon={false}
            fontSize={20}
            show={isOpen}
            titleMarginLeft={0}
            titleColor="#184287"
            handleClose={onClose}
            fontFamily="Montserrat"
            modalStyle={styles.modalMainDetailsSale}
        >
            <DetailSale
                sale={sale}
                onClose={onClose}
                onGoHome={onGoHome}
                onCustomBtn={onCustomBtn}
                customBtnText={customBtnText}
            />
        </ModalComponent>
    )
}
